import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { boardMessagesInfiniteQueryOptions } from "~/features/board/api";
import { BoardTemplate } from "~/features/board/BoardTemplate";

const boardSearchSchema = z.object({
  callWaiting: z.enum(["video", "voice"]).optional(),
  age: z
    .enum(["under20", "twenties", "thirties", "forties", "fiftyPlus"])
    .optional(),
  region: z.coerce.number().int().min(1).max(48).optional(),
});

export const Route = createFileRoute("/_authenticated/board/")({
  validateSearch: boardSearchSchema,
  loaderDeps: ({ search }) => ({
    callWaiting: search.callWaiting,
    age: search.age,
    region: search.region,
  }),
  loader: ({ context: { queryClient }, deps }) =>
    queryClient.ensureInfiniteQueryData(
      boardMessagesInfiniteQueryOptions(deps),
    ),
  component: BoardTemplate,
});
